import React, { useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import $ from "jquery";
import "jquery-ui/dist/jquery-ui.js";
import "jquery-ui/themes/base/all.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function ApprovedPaymentCont() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const tableRef = useRef(null);
    const token2 = localStorage.getItem("token2");

    useEffect(() => {
        if (!localStorage.getItem("token2")) {
            navigate("/");
          }
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.API_BASE_URL}/auth/BoardVerificationApproved`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token2}`,
                    },
                });

                if (response.status !== 200) {
                    Swal.fire({
                        icon: "warning",
                        title: "Data not found",
                        // text: "No Verification Approved found",
                    });
                    setData([]);
                } else {
                    const result = await response.json();
                    const studentData = result?.data?.board_verification_approved ?? [];

                    if (studentData.length === 0) {
                        Swal.fire({
                            icon: "warning",
                            title: "Data Not Found",
                        });
                    }
                    setData(studentData);
                    console.log(result);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                Swal.fire("Error", "Something went wrong!", "error");
                setData([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token2]);

    useEffect(() => {
        if (data.length > 0) {
            const table = $(tableRef.current).DataTable({
                paging: false,
                info: false,
                destroy: true,
                columnDefs: [{ orderable: false, targets: 0 }],
            });

            return () => {
                table.destroy();
            };
        }
    }, [data]);

    const movetodashboard = (e) => {
        e.preventDefault();
        navigate("/Board-dashboard");
    };

    return (
        <div className="pc-container">
            {loading && (
                <div className="custom-loader-container">
                    <div className="custom-loader"></div>
                </div>
            )}
            <div className="pc-content">
                <div className="page-header">
                    <div className="page-block">
                        <div className="row align-items-center">
                            <div className="col-md-12 breadcrumb">
                                <div className="page-header-title">
                                    <h5 className="m-b-10">TOTAL APPROVED PAYMENTS</h5>
                                </div>
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <a href="" onClick={movetodashboard}>
                                            Home
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="">TOTAL APPROVED PAYMENTS</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ padding: "0px" }}>
                    <div className="col-md-12">
                        <div className="card tbl-card" style={{ border: "1px solid #1890ff" }}>
                            <div className="card-body padding-10">
                                <div className="table-responsive">
                                    <table ref={tableRef} className="table table-hover table-bordered mb-0">
                                        <thead>
                                            <tr className="table-info">
                                                <th>Sl. No</th>
                                                <th>Centre Code</th>
                                                <th>Centre Name</th>
                                                <th>Challan Number</th>
                                                <th>Number of Students</th>
                                                <th>Challan Generation Date & Time</th>
                                                <th>Payment Mode</th>
                                                <th>Verification Date & Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.CENTER_CODE || "N/A"}</td>
                                                        <td>{item.CENTER_NAME || "N/A"}</td>
                                                        <td>{item.CHALLAN_NO || "N/A"}</td>
                                                        <td>{item.NO_OF_STUDENT || "N/A"}</td>
                                                        <td>{item.CHALLAN_DATE_TIME || "N/A"}</td>
                                                        <td>{item.PAYMENT_MODE || "N/A"}</td>
                                                        <td>{item.APPROVAL_DATE_TIME || "N/A"}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ApprovedPaymentCont;